import { generateKeys } from '../utils';
export const tableauReportTypes = generateKeys({
    overallSalesRetention: {
        value: 'overallSalesRetention',
        label: 'Overall Sales Retention',
        requiresParameters: false,
    },
    salesRetention: {
        value: 'salesRetention',
        label: 'Sales Retention',
        requiresParameters: true,
    },
});
